// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"29fb7a04","61":"74bbfefa","144":"2d2b8ccd","241":"b6c8c597","246":"76602992","261":"df43b738","349":"5d9a0339","464":"21828c0e","509":"26212220","534":"f6f1ed64","566":"ba97e302","787":"920914d4","894":"d54c1e99"}[chunkId] + ".chunk.js";
};